import MenuEnum from '../../../components/menu/Menu.enum.ts';
import MenuView from '../../../components/menu/Menu.view.tsx';
import React, { type CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import CardView from '../../../components/card/Card.view.tsx';
import { getDesktopMenuWidth } from '../../../tools/ConfigurationReader.ts';
import { FaBagShopping, FaInfo } from 'react-icons/fa6';
import { useReportingController } from '../Reporting.controller.ts';
import styles from './Reporting.desktop.module.css';
import { FaUser } from 'react-icons/fa';

export default function ReportingDesktopView() {
  const { t } = useTranslation();
  const {
    handleReportMarketComponentHistoryClick,
    handleReportMarketComponent_30_60_90_VerificationClick,
    handleReportMarketComponentWithoutCriticalBBDClick,
    handleReportMarketComponentWhereShortDescriptionNotEqualsNumberClick,
    handleReportUserClick,
  } = useReportingController();

  return (
    <div className={styles.main}>
      <MenuView menu={MenuEnum.Administration} />
      <div
        className={styles.mainContainer}
        style={
          {
            '--menuWidth': getDesktopMenuWidth(),
          } as CSSProperties
        }
      >
        <div className={styles.cardContainer}>
          <CardView
            icon={FaInfo}
            label={t('ui.reportMarketComponentHistory')}
            onClick={handleReportMarketComponentHistoryClick}
          />
          <CardView
            icon={FaBagShopping}
            label={t('ui.reportMarketComponent_30_60_90_Verification')}
            onClick={handleReportMarketComponent_30_60_90_VerificationClick}
          />
          <CardView
            icon={FaBagShopping}
            label={t('ui.reportMarketComponentWithoutCriticalBBD')}
            onClick={handleReportMarketComponentWithoutCriticalBBDClick}
          />
          <CardView
            icon={FaBagShopping}
            label={t('ui.reportMarketComponentWhereShortDescriptionNotEqualsNumber')}
            onClick={handleReportMarketComponentWhereShortDescriptionNotEqualsNumberClick}
          />
          <CardView icon={FaUser} label={t('ui.reportUser')} onClick={handleReportUserClick} />
        </div>
      </div>
    </div>
  );
}
